import moment from 'moment';

export enum Pattern {
  /**
   * Example: `10/2/2021 12:12am`
   */
  DATE_TIME = 'M/D/YYYY h:mma',
  /**
   * Example: `Sep 29, 2021`
   */
  DATE = 'll',
  /**
   * Example: `Sep 2021`
   */
  MONTH = 'MMM YYYY',
  /**
   * Example: `12:12am`
   */
  TIME = 'h:mma',
  /**
   * Example: `Sep 29, 2021 12:12am`
   */
  DATE_TIME_HUMAN = 'll h:mma',
  /**
   * If the date is recent, display the relative time. Otherwise, fall back to `DATE`.
   * Example: `an hour ago`. See https://momentjs.com/docs/#/displaying/fromnow/ for more info.
   */
  RELATIVE = 'RELATIVE',
  ISO_DATE = 'YYYY-MM-DD',
}

export const format = (date: Date, pattern: Pattern = Pattern.RELATIVE): string => {
  const dateMoment = moment(date);
  if (pattern === Pattern.RELATIVE) {
    if (dateMoment.isBefore(moment().subtract(1, 'week'))) {
      return dateMoment.format(Pattern.DATE);
    }
    const now = moment();
    const diff = dateMoment.diff(now, 'second');
    if (diff === 0) {
      // Replace `in 1s` with `1s` to make the UI for newly created items smoother.
      return now.subtract(1, 'second').fromNow();
    }
    return dateMoment.fromNow();
  }
  return dateMoment.format(pattern);
};

moment.locale('en', {
  relativeTime: {
    future: 'in %s',
    past: '%s',
    s: '1s',
    m: '1m',
    mm: '%dm',
    h: '1h',
    hh: '%dh',
    d: '1d',
    dd: '%dd',
    M: 'a month',
    MM: '%d months',
    y: 'a year',
    yy: '%d years',
  },
  weekdaysMin: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
});

export const sortByDate = (a: string, b: string, ascending: boolean = true) =>
  ascending ? a.localeCompare(b) : b.localeCompare(a);
